module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-26-5dccc163fb7672306d4f076982dc78b6.png";